import { getCookie, setCookie } from './cookies';
import { CS_ALERT_VIEWED_COOKIE_PREFIX } from './constants';

const getKeyForAlertId = (alertId) => `${CS_ALERT_VIEWED_COOKIE_PREFIX}_${alertId.toUpperCase()}`;

export const setAlertCookie = (alertId, alertCooldown) => {
    const key = getKeyForAlertId(alertId);

    setCookie(key, true, {
        expires: new Date(Date.now() + alertCooldown),
    });
};

export const getAlertCookie = (alertId) => getCookie(getKeyForAlertId(alertId)) || null;

export const hasCookieForAlert = (alertId) => getAlertCookie(alertId) !== null;
